// Мутации сделки, общие для карточки, списка и формы.
import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';

import {
  createDeal,
  deleteDeal,
  updateDeal,
  type CreateDealInput,
  type DealDetail,
  type UpdateDealInput,
} from '../api/deals.client.js';

const dealMutations = createEntityMutations<DealDetail, CreateDealInput, UpdateDealInput>({
  key: 'deals',
  // Сделка попадает в панели контакта и компании — их выборки тоже устаревают.
  // `hot-leads` — производная от сделок выборка: без неё правка суммы или срока
  // не доходила до списка горячих лидов и дашборда.
  alsoInvalidate: ['contacts', 'companies', 'hot-leads'],
  create: createDeal as (input: CreateDealInput) => Promise<DealDetail>,
  update: updateDeal,
  remove: deleteDeal,
});

export const useUpdateDealMutation = dealMutations.useUpdate;
export const useDeleteDealMutation = dealMutations.useDelete;
